export const languages = [
    { id: 1, title: 'en', active: true },
    { id: 2, title: 'uk', active: false },
    { id: 3, title: 'de', active: false },
]
